import React from 'react';
import {HashRouter} from 'react-router-dom';
import ReactDOM from 'react-dom';

// import './index.css';
import App from './App';
// import Home from './pages/Home';
// import Login from './pages/Login';
import registerServiceWorker from './registerServiceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));
ReactDOM.render(    
    <HashRouter>    
    <App style={{height:"100%"}} />
  </HashRouter>        
    ,
    document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js